import { render, staticRenderFns } from "./tableComs.vue?vue&type=template&id=26a05bae&scoped=true&"
import script from "./tableComs.vue?vue&type=script&lang=js&"
export * from "./tableComs.vue?vue&type=script&lang=js&"
import style0 from "./tableComs.vue?vue&type=style&index=0&id=26a05bae&prod&lang=css&"
import style1 from "./tableComs.vue?vue&type=style&index=1&id=26a05bae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a05bae",
  null
  
)

export default component.exports